import { register } from '../../../JavaScript/Utils'

const StateToggler = el => {
  const targetElement = document.querySelector(`[data-toggler-id="${el.dataset.targetId}"`)
  const togglerClass = el.dataset.togglerClass

  if (targetElement) {
    el.addEventListener('click', () => {
      targetElement.classList.toggle(togglerClass)
      el.classList.toggle(togglerClass)
    })
  }
}

register('StateToggler', StateToggler)
